import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import iconMessaging from '~/assets/svgs/icon-messaging.svg?react'
import { useUserState } from '~/atoms/UserState'
import { useMessageReceivedNotifications } from '~/hooks/useMessageReceivedNotifications'
import { useWebSocketService } from '~/hooks/useWebSocketService'
import { SiteNavigationTab } from '~/pages/Home/SiteNavigation/shared/SiteNavigationTab'
import { TabImplementationProps } from '~/pages/Home/SiteNavigation/tabImplementations/TabImplementationTypes'
import { WebSocketEventType } from '~/types'
import { useMessageGroupsViewModel } from '~/viewModels/Messaging/MessageGroupsViewModel'

export const MessagingTab = ({
  id,
  isSelected,
  isCollapsed,
  onClick,
}: TabImplementationProps) => {
  const { t } = useTranslation()
  //while the tab is mounted, send browser notifications when a new message is received
  useMessageReceivedNotifications()
  const { userMessageGroups, tryFetchUserMessageGroups } =
    useMessageGroupsViewModel()

  function calculateTextTotal() {
    return (userMessageGroups ?? [])
      .map((grp) => grp.unread_indicator_count)
      .reduce((acc, curr) => acc + curr, 0)
  }

  //subscribe to thread updates -> refetch message groups to show unread count
  const { pbxId } = useUserState()
  const { subscribe: wssSubscribe } = useWebSocketService()

  wssSubscribe(WebSocketEventType.ThreadUpdated, {
    subscriptionToken: 'MessagingTab:ThreadUpdated',
    callback: (_) => tryFetchUserMessageGroups(),
  })

  //fetch message groups initial state on mount
  useEffect(() => {
    tryFetchUserMessageGroups()
  }, [pbxId])

  const notificationCount = calculateTextTotal()

  return (
    <SiteNavigationTab
      id={id}
      title={t('nav.text')}
      icon={iconMessaging}
      isSelected={isSelected}
      isCollapsed={isCollapsed}
      onClick={onClick}
      notificationCount={notificationCount}
    />
  )
}
